/* BR display localization; never changes prices, variant values or checkout totals. */
(() => {
  'use strict';
  const locale = (window.JuanaThemeI18n?.locale || '').toLowerCase();
  const isPortuguese = locale.startsWith('pt');
  const colors = window.JuanaThemeI18n?.colors || {};
  function translateValues(scope = document) {
    if (!isPortuguese && !locale.startsWith('nl')) return;
    scope.querySelectorAll('.product-form__option-value, .select__selected-value').forEach(el => {
      const value = el.textContent.trim();
      if (colors[value]) el.textContent = colors[value];
    });
  }
  translateValues();
  document.addEventListener('change', () => requestAnimationFrame(() => translateValues()));
  document.addEventListener('variant:changed', () => translateValues());
  document.addEventListener('shopify:section:load', event => translateValues(event.target));
  document.addEventListener('change', event => {
    if (event.target.name !== 'country_code' || !event.target.closest('.jf-localization')) return;
    const language = event.target.form?.querySelector('[name="language_code"]');
    if (!language) return;
    const preferred = {BR: ['pt-BR','pt'], PL: ['pl'], US: ['en'], BE: ['nl'], NL: ['nl']}[event.target.value] || [];
    const available = [...language.options].find(option => preferred.includes(option.value));
    if (available) language.value = available.value;
  });
})();
